import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss'],
})
export class DialogBoxComponent implements OnInit {
  form: UntypedFormGroup;
  constructor(private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: { message: string },
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    public helperService: HelperService) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', [Validators.required,
        Validators.pattern(/^[^\s].*$/)]],
    });
    if (this.helperService.isUpdatConversationName) {
      this.form.patchValue({ name: this.helperService.newConversationName })
    }
  }

  bridgenameCheck(event) {
    return ((event.keyCode >= '65' && event.keyCode <= '90') || (event.key >= '0' && event.key <= '9') || ['ArrowLeft', 'ArrowRight', 'Backspace', ' ','_'].includes(event.key))
  }

  submit(form: NgForm) {
    if (this.form.invalid) {
      return;
    }
    this.dialogRef.close({
      clicked: 'submit',
      form: form,
    });
  }

}
